module.exports = __webpack_public_path__ + "static/media/COVID.0685327b.jpg";